document.addEventListener('DOMContentLoaded', () => {

  $('[data-accordion]').each((index, $accordion) => {

    const activeItem = { item: null, body: null }

    $($accordion)
      .find('[data-accordion-item]')
      .each((index, $item) => {
        const $trigger = $item.querySelectorAll('[data-accordion-trigger]') ?? []
        const $body = $item.querySelector('[data-accordion-body]')

        //* если нет body завершаем функцию.
        if (!$body) return

        $($trigger).on('click', () => {
          if (activeItem.item !== $item) {
            //* убираем className/закрываем body у прошлого item
            $(activeItem.item).removeClass('accordion--active')
            $(activeItem.body).slideUp(250)
            //* добавляем новому item
            $($item).addClass('accordion--active')
            $($body).slideDown(250)
            //* записываем новый item
            activeItem.item = $item
            activeItem.body = $body
          } else {
            $($item).toggleClass('accordion--active')
            $($body).slideToggle(250)
          }
          return false
        })
      })
  })

})

/* 
* Базовая разметка:
  
*/
